export default "__VITE_ASSET__CWVF2nel__"